import Utils from '../utils/utils';
const EventEmitter = require('eventemitter3');

class AudioChannel extends EventEmitter {
    //
    constructor(name, params) {
        super();

        this.defaults = {
            startLoad: true,
            loop: false,
            defaultMuted: false,
            volumeRatio: 1 /* ,
            muteDuration: 300*/
        };

        this.name = name;
        this._params = Utils.extend(this.defaults, params);

        // ARRAY, OBJECT {src: , type: } or STRING
        this._audioSRC = this._params.src || [];

        this._volumeValue = 1;
        this._init();
    }

    _init() {
        this._failed = false;
        this._lastFixedProgress = -1;
        this._muted = this._params.defaultMuted;

        this._container = document.createElement('DIV');
        this._container.style.visibility = 'hidden';
        this._container.setAttribute('id', 'audio_' + this.name);

        this._audio = document.createElement('AUDIO');
        this._audio.setAttribute('preload', 'none');

        if (this._params.loop) this._audio.setAttribute('loop', 'loop');

        this._container.appendChild(this._audio);
        document.body.appendChild(this._container);

        if (this._audio.length < 1) {
            this._failed = true;
            return;
        }

        const _getSrc = (s, type) => {
            const src = document.createElement('SOURCE');
            src.setAttribute('src', s);

            if (type) src.setAttribute('type', type);

            return src;
        };

        let i, s;
        if (typeof this._audioSRC === 'string') {
            //
            this._audio.appendChild(_getSrc(this._audioSRC));
            //
        } else if (typeof this._audioSRC.push === 'function') {
            //
            for (i = 0; i < this._audioSRC.length; i++) {
                s = this._audioSRC[i];
                this._audio.appendChild(_getSrc(s.src, s.type));
            }
            //
        } else {
            this._audio.appendChild(_getSrc(this._audioSRC.src, this._audioSRC.type));
        }

        this._src = [...this._audio.querySelectorAll('source')];
        //

        this.lr1 = _onCanplaythrough.bind(this);
        this.lr2 = _onCanplay.bind(this);
        this.lr3 = _onLoadstart.bind(this);
        this.lr4 = _onWaiting.bind(this);
        this.lr5 = _onUpdate.bind(this);
        this.lr6 = _onError.bind(this);
        this.lr7 = _onEnded.bind(this);
        this.lr8 = _onPlaying.bind(this);

        function _onCanplaythrough(evt) {
            // console.log(evt);
            this._loaded = true;
            _onCanplay.apply(this, [evt]);
        }

        function _onCanplay() {
            // console.log(evt)

            this._setCanplay();
        }

        function _onLoadstart() {
            // console.log(evt)
        }

        function _onUpdate(evt) {
            let a;
            if (this._audio && this._audio.duration) {
                //
                if (!this._playing) {
                    this._playing = true;
                    _onPlaying.apply(this, [evt]);
                }

                a = (100 * this._audio.currentTime) / this._audio.duration;
                if (Math.floor(a / 25) > 0 && Math.floor(a / 25) > Math.floor(this._lastFixedProgress / 25)) {
                    if (this._progressInformCMD) this._progressInformCMD.execute(25 * Math.floor(a / 25));
                    this._lastFixedProgress = a;
                }

                if (a >= 99.99999 && this._playing) {
                    this._playing = false;
                    this.emit('complete', this);
                }
            }
        }

        function _onWaiting() {
            // console.log(evt);
            this._setBuffering();
        }

        function _onPlaying() {
            // console.log(evt);
            this._setPlaying();
            this.emit('started', this);
        }

        function _onError(evt) {
            // console.log(evt);

            if (evt.currentTarget instanceof HTMLElement) {
                evt.currentTarget.dataset.error = true;
            }

            _checkErrors.apply(this);
        }

        function _checkErrors() {
            let i, src, n;
            for (i = 0, n = 0; i < this._src.length; i++) {
                src = this._src[i];
                if (src.dataset.error) n++;
            }
            if (!this._audio.dataset.playing && n >= this._src.length) {
                this._errorHandler();
            }
        }

        function _onEnded() {
            // console.log(evt)

            if (Math.floor(this._lastFixedProgress / 25) < 100 / 25) {
                if (this._progressInformCMD) this._progressInformCMD.execute(100);
                this._lastFixedProgress = 100;
            }

            this._completeHandler();
        }

        this._addAudioListeners(true);

        if (this._params.startLoad) {
            try {
                this._audio.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }
    }

    start() {
        if (this._started && this._params.loop) return;
        this._started = true;
        // if (this._to) clearTimeout(this._to);

        if (this._played) {
            this._audio.pause();
            this._audio.currentTime = 0;
            this._lastFixedProgress = -1;
        }

        if (this._params.startLoad || this._loaded) {
            //
            if (!this._failed) {
                try {
                    if (this._playInformCMD) this._playInformCMD.execute();

                    this._played = true;
                    this._audio.volume = this._volumeValue * this._params.volumeRatio;
                    this._audio.muted = this._muted;

                    if (this._played) this._addAudioListeners(true);

                    this._audio.play();
                } catch (e) {
                    this._errorHandler(e);
                }
            }
        } else {
            try {
                this._audio.load();
            } catch (e) {
                this._errorHandler(e);
            }
        }
    }

    reset() {
        this._failed = false;
        this._loaded = false;
    }

    stop() {
        this._started = false;
        this._addAudioListeners(false);
        this._audio.pause();
    }

    unmute() {
        this._audio.muted = this._muted = false;
    }

    mute() {
        this._audio.muted = this._muted = true;
    }

    destroy() {
        if (this._container.parentNode) this._container.parentNode.removeChild(this._container);
    }

    get volume() {
        return this._volumeValue;
    }

    set volume(value) {
        this._volumeValue = value;
        if (this._audio) this._audio.volume = this._volumeValue * this._params.volumeRatio;
    }

    _addAudioListeners(b) {
        //
        if (b) {
            this._audio.dataset.playing = false;
            this._audio.addEventListener('canplaythrough', this.lr1);
            this._audio.addEventListener('canplay', this.lr2);
            this._audio.addEventListener('loadstart', this.lr3);
            this._audio.addEventListener('waiting', this.lr4);
            this._audio.addEventListener('timeupdate', this.lr5);
            this._audio.addEventListener('error', this.lr6);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++) {
                    this._src[i].dataset.error = false;
                    this._src[i].addEventListener('error', this.lr6);
                }
            }
            this._audio.addEventListener('ended', this.lr7);
            this._audio.addEventListener('playing', this.lr8);

            if (this._audio.readyState > 3) {
                this.lr1();
            } else if (this._audio.readyState > 2) {
                this.lr2();
            }
        } else {
            this._audio.removeEventListener('canplaythrough', this.lr1);
            this._audio.removeEventListener('canplay', this.lr2);
            this._audio.removeEventListener('loadstart', this.lr3);
            this._audio.removeEventListener('waiting', this.lr4);
            this._audio.removeEventListener('timeupdate', this.lr5);
            this._audio.removeEventListener('error', this.lr6);
            this._audio.removeEventListener('ended', this.lr7);
            if (this._src) {
                for (let i = 0; i < this._src.length; i++) {
                    this._src[i].removeEventListener('error', this.lr6);
                }
            }
            this._audio.removeEventListener('playing', this.lr8);
        }
    }

    _setCanplay() {
        if (this._failed) return;

        if (this._started) {
            //
            if (!this._failed) {
                try {
                    if (this._playInformCMD) this._playInformCMD.execute();
                    this._played = true;
                    this._started = true;
                    this._audio.volume = this._volumeValue * this._params.volumeRatio;
                    this._audio.muted = this._muted;
                    this._audio.play();
                } catch (e) {
                    this._errorHandler();
                }
            }
        }
    }

    _setPlaying() {
        if (this._failed) return;

        this._audio.dataset.playing = true;
        this._container.dataset.playing = true;
        this._container.dataset.buffering = false;
    }

    _setBuffering() {
        if (this._failed) return;

        this._audio.dataset.playing = false;
        this._container.dataset.playing = false;
        this._container.dataset.buffering = true;
    }

    _completeHandler() {
        if (this._failed) return;
        this._container.dataset.buffering = false;
    }

    _errorHandler() {
        // console.log(evt)
        this._failed = true;
        this._container.dataset.buffering = false;
    }

    setPlayInformCommand(cmd) {
        this._playInformCMD = cmd;
    }

    setProgressInformCommand(cmd) {
        this._progressInformCMD = cmd;
    }
}

export {AudioChannel};
export default AudioChannel;
